import React from 'react';

function ProfileImage(props) {
    return (
      <div className="profile-image">
        <img src={props.src} />
      </div>
    );
}

export default ProfileImage;
